import {
    selectAppStateSlice,
} from '../../selectors';
import NAMESPACE from './types';

function selectData(appState) {
    return selectAppStateSlice(appState)[NAMESPACE];
}

function selectNewRouteLinks(appState, newRoutesId) {
    return selectAppStateSlice(appState)[NAMESPACE][newRoutesId];
}

export {
    selectData,
    selectNewRouteLinks,
};
